(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rtm-lotus-motion-test"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rtm-reading-test')) {
  customElements.define('rtm-reading-test', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frames = new Set();
      const signal = this.controller.signal;
      const story = this.querySelector('article');
      const end = this.querySelector('[data-reading-end]');
      const bar = this.querySelector('[role="progressbar"]');
      const fill = bar?.querySelector('.lot-reading-progress__fill');
      if (!story || !end || !bar || !fill) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        this.progressFrame = 0;
        const start = story.getBoundingClientRect().top + window.scrollY;
        const finish = end.getBoundingClientRect().top + window.scrollY - window.innerHeight;
        const range = finish - start;
        const progress = range > 0 ? Math.min(1, Math.max(0, (window.scrollY - start) / range)) : (end.getBoundingClientRect().top <= window.innerHeight ? 1 : 0);
        fill.style.transform = `scaleX(${progress})`;
        bar.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
        bar.hidden = false;
      };
      const schedule = () => {
        if (!this.progressFrame) this.progressFrame = requestAnimationFrame(update);
      };
      addEventListener('scroll', schedule, { passive: true, signal });
      addEventListener('resize', schedule, { signal });
      addEventListener('pageshow', schedule, { signal });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(story);
      }
      this.querySelectorAll('img').forEach(img => img.addEventListener('load', schedule, { once: true, signal }));
      document.fonts?.ready.then(() => { if (!signal.aborted) schedule(); });
      const counters = this.querySelectorAll('[data-count-to]');
      const animate = el => {
        const target = Number(el.dataset.countTo);
        const decimals = Number(el.dataset.countDecimals || 0);
        const duration = 1200;
        if (!Number.isFinite(target) || reduced.matches) return;
        const panel = el.closest('.lot-motion-stat');
        panel?.classList.add('is-counting');
        const began = performance.now();
        const tick = now => {
          this.frames.delete(frame);
          if (signal.aborted) return;
          const t = Math.min(1, Math.max(0, (now - began) / duration));
          el.textContent = reduced.matches || t === 1 ? target.toFixed(decimals) : (target * (1 - Math.pow(1 - t, 3))).toFixed(decimals);
          if (t < 1 && !reduced.matches) {
            frame = requestAnimationFrame(tick);
            this.frames.add(frame);
          } else {
            panel?.classList.remove('is-counting');
            panel?.classList.add('is-counted');
          }
        };
        el.textContent = (0).toFixed(decimals);
        let frame = requestAnimationFrame(tick);
        this.frames.add(frame);
      };
      if ('IntersectionObserver' in window && !reduced.matches) {
        this.counterObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.counterObserver.unobserve(entry.target);
            animate(entry.target);
          });
        }, { threshold: 0.55 });
        counters.forEach(el => this.counterObserver.observe(el));
      }
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.counterObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.progressFrame);
      this.frames?.forEach(frame => cancelAnimationFrame(frame));
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
